import AuthorizationService from "../services/authorizationService";
import RepositoryBase from "./repositoryBase";
import Redirect from "../models/redirect";
import EshopError from "../models/eshopError";
import { plainToClass } from "class-transformer";
import EshopRequestBuilder from "../data/eshopRequestBuilder";
import EventBus from "../services/eventBus";

const POST_NIA_AUTH_REQUEST_FAILURE = "POST_NIA_AUTH_REQUEST_FAILURE";

export default class NiaRepository extends RepositoryBase<EshopRequestBuilder> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(() => apiFactory(), authorizationService, eventBus);
  }

  niaRedirect = () =>
    this.callApi(api =>
      api
        .one("nia/auth_request")
        .clearPost({})
        .then(async response => {
          if (!response.ok) return plainToClass(EshopError, (await response.json()) as EshopError);

          return plainToClass(Redirect, (await response.json()) as Redirect);
        })
        .catch(() => {
          throw new EshopError(POST_NIA_AUTH_REQUEST_FAILURE);
        })
    );
}
